<template>
  <avs-card>
    <template v-slot:title>
      <v-toolbar
        class="mt-4 custom-toolbar"
        elevation="0"
      >
        <v-text-field
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          :label="$t('commons.search')"
          v-model="search"
        />
        <slot
          name="actions"
          v-bind:dataset="dataset"
        />
      </v-toolbar>
    </template>
    <template v-slot:content>
      <v-data-table
        class="ma-10"
        :headers="headers"
        :no-data-text="$t('messages.information.no_data')"
        :search="search"
        :items="dataset"
        :loading-text="$t('categories.cfsi.loading')"
        :no-results-text="$tc('categories.cfsi.name', 0)"
        :loading="loading"
        disable-pagination
        hide-default-footer
        @dblclick:row="($event, { item }) => toEdit(item)"
      >
        <template #item.report_date="{ item }">
          {{ toDate(item.report_date) }}
        </template>
        <template v-slot:item.status="{ item }">
          <component :is="handleStatusComponent(item)" />
        </template>
        <template v-slot:item.quick_description="{ item }">
          {{ truncate(item.quick_description) }}
        </template>
        <template v-slot:item.pictures="{ item }">
          <v-chip>
            <v-icon left>mdi-image-multiple</v-icon>
            {{ item.pictures.length }} {{ $tc("commons.picture", 2) }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-end">
            <avs-editButton
              @click.stop="toEdit(item)"
              :spantext="
                $t('actions.edit', {
                  entity: $tc('categories.cfsi.name', 1).toLowerCase()
                })
              "
            />
            <!-- <avs-duplicateButton
              @click.stop="$event => duplicateCfsi(item)"
              :spantext="
                $t('actions.duplicate', {
                  entity: $tc('categories.cfsi.name', 1).toLowerCase()
                })
              "
            /> -->
            <avs-deleteButton
              :disabled="isNCSigned(item)"
              @click="handleOpenDeleteDialog(item)"
              :spantext="
                $t('actions.delete', {
                  entity: $tc('categories.cfsi.name', 1).toLowerCase()
                })
              "
            />
          </div>
        </template>
      </v-data-table>
      <avs-deleteDialog
        v-model="deleteDialogIsOpen"
        @cancel="handleCancel"
        @delete="handleDelete"
        resource="Cfsi"
      /> </template
  ></avs-card>
</template>

<script>
import { truncate } from "lodash"
// import _ from "lodash"
import CfsiService from "@/services/CfsiService"
import { toDate } from "@/utils/datetime"
import { Closed, Ongoing, Overdue, Pending } from "@/components/generics/status"
import { dateToString, now, FMTS } from "@/utils/datetime"

export default {
  name: "CfsisTable",
  components: { Closed, Ongoing, Overdue, Pending },
  props: {
    inspectionId: {
      type: Number,
      default: null
    }
  },
  computed: {
    projectId() {
      return this.$store.state.app.project.id
    }
  },
  data() {
    return {
      deleteDialogIsOpen: false,
      selectedItem: null,
      search: "",
      loading: false,
      dataset: [],
      headers: [
        {
          text: this.$t("commons.cfsi_reference"),
          value: "cfsi_reference",
          class: "min-width-150"
        },
        { text: this.$t("commons.date.report_date"), value: "report_date", class: "min-width-150" },
        { text: this.$tc("commons.picture", 2), value: "pictures", align: "center" },
        { text: this.$t("commons.status.name"), value: "status" },
        { text: this.$t("commons.actions"), value: "actions", align: "right", width: 100 }
      ]
    }
  },
  methods: {
    truncate,
    toDate,
    getToEditLink(item) {
      return {
        name: "CfsiCreateUpdate",
        params: { id: item.id }
      }
    },
    getCfsis() {
      let t = this
      this.loading = true
      if (this.inspectionId) {
        CfsiService.getByInspection(this.projectId, this.inspectionId)
          .then(r => {
            t.dataset = r.results
          })
          .catch(err => {
            if (err.response && err.response.status === 403) {
              // alert("Access denied: You do not have permission to access this resource.")
              this.$store.commit("app/message", {
                msg: this.$t("messages.error.permission_denied"),
                color: "error"
              })
            }
          })
          .finally(() => {
            t.loading = false
          })
      } else {
        CfsiService.get(this, this.projectId)
          .then(r => {
            t.dataset = r.results
          })
          .catch(err => {
            if (err.response && err.response.status === 403) {
              // alert("Access denied: You do not have permission to access this resource.")
              this.$store.commit("app/message", {
                msg: this.$t("messages.error.permission_denied"),
                color: "error"
              })
            }
          })
          .finally(() => {
            t.loading = false
          })
      }
    },
    handleDelete(item) {
      CfsiService.remove(this, this.selectedItem.id).then(r => {
        this.dataset = this.dataset.filter(e => e.id !== this.selectedItem.id)
        this.$store.commit("app/message", {
          msg: this.$t("messages.success.deleted", {
            entity: this.$tc("categories.cfsi.name", 1)
          }),
          color: "success"
        })
      })
      this.deleteDialogIsOpen = false
    },
    handleOpenDeleteDialog(item) {
      this.deleteDialogIsOpen = true
      this.selectedItem = item
    },
    handleCancel() {
      this.deleteDialogIsOpen = false
    },
    handleStatusComponent(task) {
      return task.status
    },
    toEdit(item) {
      this.$router.push(this.getToEditLink(item))
    },
    isNCSigned(item) {
      return item.state === 4
    },
    async duplicateCfsi(p) {
      CfsiService.get(this, this.projectId, p.id)
        .then(async response => {
          // Override some keys
          let date = dateToString(now(), FMTS.FILE)
          response.nc_number = `${response.nc_number}-${date}`
          response.status = "Ongoing"
          response.lang = this.$i18n.locale

          // Téléchargez les images existantes et créez les nouvelles images
          let picturePromises = response.pictures.map(async picture => {
            let imageBlob = await fetch(picture.file_url).then(res => res.blob())

            // Convertir l'image Blob en base64
            let reader = await new Promise((resolve, reject) => {
              let fileReader = new FileReader()
              fileReader.onloadend = () => resolve(fileReader.result)
              fileReader.onerror = reject
              fileReader.readAsDataURL(imageBlob)
            })

            return {
              file: reader,
              label: "",
              hover: false,
              removed: false,
              timestamp: Date.now()
            }
          })

          // Attendez que toutes les promesses d'images soient résolues
          response.pictures = await Promise.all(picturePromises)

          // On Créé l'inspection
          CfsiService.create(this, this.projectId, response.inspection.id, response)
            .then(res => {
              this.$store.commit("app/message", {
                msg: this.$t("messages.success.duplicated", {
                  entity: this.$tc("categories.cfsi.name", 1)
                }),
                color: "success"
              })
              this.getCfsis()
            })
            .catch(error => {
              this.$emit("error", error)
            })
        })
        .catch(e => {
          if (e.status) {
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.not_allowed_duplicated"),
              color: "error"
            })
          }
        })
    }
  },
  mounted() {
    this.getCfsis()
    if (!this.inspectionId) {
      // eslint-disable-next-line prettier/prettier
      this.headers.unshift({ text: this.$tc("categories.nonconformity.name", 1), value: "non_conformity.nc_number", class: "min-width-200" })
    }
  }
}
</script>

<style scoped>
.custom-toolbar >>> .v-toolbar__content {
  gap: 1rem;
}
</style>
